// Date and time related texts
export const DATE_TIME_TEXTS = {
  justNow: 'just now',
  minutesAgo: (minutes: number) => `${minutes} min${minutes > 1 ? 's' : ''} ago`,
  noData: 'N/A',
  compactFallback: '-'
} as const;